
import config from "../../config";
import { create_set_bot_Group, create_set_Bot_Group_List } from "../Create_New_bot/reducer";
import { fetchGroup_Details_Failed, fetchGroup_Details_Success, start_group_Deatils_fetch_loading } from "../Owner_Group/reducer";
import { open_success_modal } from "../Success_Modal/reducer";
import { GET_GROUP_USER_DETAILS, group_owner_details } from "../thunks";
import {
  create_new_group,
  delete_group_by_group_id,
  get_BotListGroup,
  get_group_details,
  leave_group_by_id,
  update_group_info,
  update_group_user,
} from "./../../helpers/fakebackend_helper";

// action
import {
  fetchGroupListSuccess,
  fetchGroupListFailed,
  reset_group_flag,
  start_group_fetch_loading,
  create_new_group_success,
  start_update_group_user_loading,
  update_group_user_sucess,
  update_group_user_fail,
  set_open_create_new_bot,
  set_no_group_Created,
  delete_group_fail
} from "./reducer";



export const group_list = (filterData) => async (dispatch , getState) => {


  
  try {
    let response;
      dispatch(start_group_fetch_loading())  
      
      // console.log(getState().Group_List.No_Group_Created, "Get State ");
      

      response = get_BotListGroup(filterData);
      const data = await response;
     
      // console.log(getState().Group_List.No_Group_Created &&  data.data.length !== 0);

      // console.log(data.data.length !== 0);
      
      

      if(getState().Group_List.No_Group_Created &&  data.data.length !== 0) {
        
          dispatch(fetchGroupListSuccess(data));
          dispatch(create_set_bot_Group(data.data[0].Group_ID))
          dispatch(set_no_group_Created(false)) 
          dispatch(set_open_create_new_bot(true))
          dispatch(create_set_Bot_Group_List(data.data))
      }else{
        dispatch(fetchGroupListSuccess(data));
      }


    

    
  } catch (error) {
    
    dispatch(fetchGroupListFailed(error));
  }
};

export const Create_New_Group = (filterData) => async (dispatch) => {
  
  try {
    let response;
         dispatch(start_group_fetch_loading())      

      response = create_new_group(filterData);
      const new_group_resposne = await response;

      dispatch(group_list({
        page:1,
        per_page:config.general_config.PER_PAGE_CONTENT
      }))
      
      
      
      dispatch(create_new_group_success());
      dispatch(open_success_modal("New Group is Created"))
    
  } catch (error) {
    
    dispatch(fetchGroupListFailed(error));
  }
};

export const update_group_info_ = (filterData) => async (dispatch) => {





      try {
        dispatch(start_group_Deatils_fetch_loading())  
       
        const resposne = update_group_info(filterData);

        await resposne



        let response;
             dispatch(start_group_fetch_loading())      
    
          response = get_group_details(filterData);
          const data = await response;
    
    
        
    
            dispatch(fetchGroup_Details_Success(data));
        
      } catch (error) {
        
        dispatch(fetchGroup_Details_Failed(error));
      }


}


export const Update_Group_User = (filterData) => async (dispatch) => {
  
  try {
    let response;
         dispatch(start_group_fetch_loading())      

      response = create_new_group(filterData);
      const new_group_resposne = await response;

      dispatch(group_list({
        page:1,
        per_page:config.general_config.PER_PAGE_CONTENT
      }))
      
      
      
      dispatch(create_new_group_success());
      dispatch(open_success_modal("New Group is Created"))
    
  } catch (error) {
    
    dispatch(fetchGroupListFailed(error));
  }
};


export const reset_group_list = () => {
  try {
    const response = reset_group_flag();
    return response;
  } catch (error) {
    return error;
  }
};


export const create_update_group_user = (filterData) => async (dispatch)=>{
  try {
    let response;
         dispatch(start_update_group_user_loading())      

      response = update_group_user(filterData);
      const new_group_resposne = await response;
     
     
      
      
      
      dispatch(update_group_user_sucess());
      // dispatch(group_owner_details({ group_id:filterData.Group_ID }))
      dispatch(open_success_modal("Group User Updated"))
      dispatch(GET_GROUP_USER_DETAILS({ group_id:filterData.Group_ID }))
    
  } catch (error) {
    
    dispatch(update_group_user_fail(error));
  }
}


export const leave_group = (filterData,navigation) => async (dispatch)=>{
  try {
    let response;
         dispatch(start_update_group_user_loading())      

      response = leave_group_by_id(filterData);
      const new_group_resposne = await response;
     
     
      
      
      
      dispatch(update_group_user_sucess());
      // dispatch(group_owner_details({ group_id:filterData.Group_ID }))
      dispatch(open_success_modal("Group Leaved Successfully"))
      navigation('/groups')
    
  } catch (error) {
    
    dispatch(update_group_user_fail(error));
  }
}



export const DELETE_GROUP = (filterData) => async (dispatch)=>{

  
  try {
    let response = delete_group_by_group_id(filterData) ;
         dispatch(start_group_fetch_loading())      
         await response;
     
     
      
      
      
      
      
      dispatch(group_list({
        page:1,
        per_page:config.general_config.PER_PAGE_CONTENT
      }))
      dispatch(open_success_modal("Group Deleted Successfully"))

    
  } catch (error) {
    
    dispatch(delete_group_fail(error));
  }
}



